import { Injectable } from '@angular/core';

import { Actions, ofType, createEffect } from '@ngrx/effects';

import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

import {
  AuthActionTypes,
  LoginSuccess,
  LoginFailure,
  Logout
} from '../actions';
import { tokenResponse } from '../../models';
import { AuthService } from '../../services';
import { Go } from 'src/app/domains/router';
import { ActivatedRoute } from '@angular/router';

@Injectable()
export class AuthEffects {

  login$ = createEffect(
    () => this.actions$.pipe(
      ofType(AuthActionTypes.Login),
      switchMap(() => {
        return this.service.loginWithCF().pipe(
          map(
            (data: tokenResponse) => new LoginSuccess({
              token: data.access_token,
              jwt: data.jwt,
              username: data.userName
            })
          ),
          catchError(error => of(new LoginFailure({ error })))
        );
      })
    )
  )

  loginSuccess$ = createEffect(
    () => this.actions$.pipe(
      ofType(AuthActionTypes.LoginSuccess),
      map(() => {
        const returnUrl = this.routerSnapshot.snapshot.queryParamMap.get('returnUrl');
        return new Go({ path: [returnUrl ? returnUrl : '/dashboard'] });
      })
    )
  )

  logout$ = createEffect(
    () => this.actions$.pipe(
      ofType(AuthActionTypes.Logout),
      map((action: Logout) => {
        localStorage.removeItem("token");
        localStorage.removeItem("jwt");
        localStorage.removeItem("username");
        // Delete CF cookie to avoid auto re-login
        // uncomment if we need automatic re-login :)
        // document.cookie = `CF_Authorization=; expires=${new Date('01/01/1970 GMT').toUTCString()}`;
        return new Go({ path: ['/login'], queryParams: { returnUrl:  action.payload.returnUrl } })
      })
    )
  )
  constructor(
    private actions$: Actions,
    private service: AuthService,
    private routerSnapshot: ActivatedRoute
  ) { }
}
